module.exports = "\n<div class=\"fixed-bottom\" id =\"footer\">\n  \n    Cat WorldBG 2018\n  \n</div>\n"